import React, { useEffect, useState } from 'react';
import { BrowserRouter, Routes, Route, Navigate, useLocation } from 'react-router-dom';
import AdminLogin from './Pages/AdminLogin';
import AdminDashboard from './Pages/AdminDashboard';
import AdminAudit from './Pages/AdminAudit';
import ThemeManager from './Pages/ThemeManager';
import AdminShipments from './Pages/AdminShipments';
import AdminOrderReports from './Pages/AdminOrderReports';
import AdminLabelPrint from './Pages/AdminLabelPrint';
import GeneralSettings from './Pages/GeneralSettings';
import AdminDiscounts from './Pages/AdminDiscounts';
import AdminReviews from './Pages/AdminReviews';
import AdminPos from './Pages/AdminPos';
import AdminPosCallback from './Pages/AdminPosCallback';
import './App.css';

function ScrollToTopButton() {
  const location = useLocation();
  const [visible, setVisible] = useState(false);

  const pathname = String(location?.pathname || '');
  const isAdminRoute = pathname.startsWith('/admin') && pathname !== '/admin/login';

  useEffect(() => {
    if (!isAdminRoute) {
      setVisible(false);
      return undefined;
    }

    const onScroll = () => {
      setVisible(window.scrollY > 450);
    };

    window.addEventListener('scroll', onScroll, { passive: true });
    onScroll();
    return () => window.removeEventListener('scroll', onScroll);
  }, [isAdminRoute, pathname]);

  if (!isAdminRoute || !visible) return null;

  return (
    <button
      type="button"
      className="scroll-top-btn"
      onClick={() => window.scrollTo({ top: 0, behavior: 'smooth' })}
      aria-label="Scroll to top"
      title="Scroll to top"
    >
      <i className="fas fa-arrow-up" aria-hidden="true"></i>
    </button>
  );
}

function App() {
  const enablePos = String(process.env.REACT_APP_ENABLE_POS || '').toLowerCase() === 'true';

  return (
    <BrowserRouter>
      <div className="App">
        <ScrollToTopButton />
        <Routes>
          {/* Redirect bare root to admin login */}
          <Route path="/" element={<Navigate to="/admin/login" replace />} />

          {/* Keep old non-prefixed paths working by redirecting them */}
          <Route path="/login" element={<Navigate to="/admin/login" replace />} />
          <Route path="/dashboard" element={<Navigate to="/admin/dashboard" replace />} />

          {/* Primary admin routes used in production */}
          <Route path="/admin/login" element={<AdminLogin />} />
          <Route path="/admin/general" element={<GeneralSettings />} />
          <Route path="/admin/reviews" element={<AdminReviews />} />
          <Route path="/admin/discounts" element={<AdminDiscounts />} />
          <Route path="/admin/dashboard" element={<AdminDashboard />} />
          <Route path="/admin/fulfillment" element={<Navigate to="/admin/reports/fulfillment" replace />} />
          <Route path="/admin/audit" element={<AdminAudit />} />
          <Route path="/admin/theme" element={<ThemeManager />} />
          <Route path="/admin/shipments" element={<AdminShipments />} />
          <Route path="/admin/labels/print" element={<AdminLabelPrint />} />
          <Route path="/admin/reports/orders" element={<AdminOrderReports />} />
          <Route path="/admin/reports/fulfillment" element={<AdminOrderReports />} />

          {enablePos ? <Route path="/admin/channels/pos" element={<AdminPos />} /> : null}
          {enablePos ? <Route path="/admin/channels/pos/callback" element={<AdminPosCallback />} /> : null}
        </Routes>
      </div>
    </BrowserRouter>
  );
}

export default App;
